<template>
    <div class="bt light-gray b--light-gray pv4 ph3 ph4-ns mid-gray flex items-cente" @click="$emit('click')">
        <div class="mr2 flex items-center">
            <img src="@/assets/img/icon_back_simple_yellow.svg">     
        </div>
        <h6 class="yellow"> {{categoryName}} </h6> 
    </div>
</template>

<script>
export default {
    props: {
        categoryName: {
            type: String
        }
    }
};
</script>
